import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Runtime, useSiteInfo } from "@silvertours/front-entities";
import { useMedia } from "react-use";
import { TrustPilotDe, TrustPilotFr } from "./TrustElements/TrustPilot";
import { AppPromotion } from "./TrustElements/AppPromotion";
import { TrustElement, TrustWrapper } from "./TrustSeals.styles";
var TrustSeals = function() {
    var ref = useSiteInfo(), featureToggles = ref.settings.featureToggles;
    var language = Runtime.useLocale().language;
    var isLargeViewport = useMedia("(min-width: 992px)", false);
    if (!isLargeViewport || !featureToggles.trustElementOnStageImage) {
        return null;
    }
    if (language === "de") {
        return /*#__PURE__*/ _jsxs(TrustWrapper, {
            children: [
                /*#__PURE__*/ _jsx(TrustElement, {
                    isHighlighted: true,
                    children: /*#__PURE__*/ _jsx(AppPromotion, {})
                }),
                /*#__PURE__*/ _jsx(TrustElement, {
                    children: /*#__PURE__*/ _jsx(TrustPilotDe, {})
                })
            ]
        });
    }
    if (language === "fr") {
        return /*#__PURE__*/ _jsxs(TrustWrapper, {
            children: [
                /*#__PURE__*/ _jsx(TrustElement, {
                    isHighlighted: true,
                    children: /*#__PURE__*/ _jsx(AppPromotion, {})
                }),
                /*#__PURE__*/ _jsx(TrustElement, {
                    children: /*#__PURE__*/ _jsx(TrustPilotFr, {})
                })
            ]
        });
    }
    return null;
};
export { TrustSeals };
